import { useContext, useEffect, useState } from 'react';
import moment from 'moment';

import { GlobalContext } from '../../../../../store';
import { IAdminEvent } from '../../../../../store/admin/events/store';
import { ISeason } from '../../../../../store/seasons/store';

import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';

export const useEventFitsInEventsSeasons = () => {
  const { seasons } = useContext(GlobalContext);
  const { clubId } = useRouteInfoState();

  const [clubSeasons, setClubSeasons] = useState<ISeason[]>([]);

  useEffect(() => {
    if (clubId && seasons[clubId]) {
      setClubSeasons(seasons[clubId].seasons);
    }
  }, [seasons, clubId]);

  const eventFitsInEventsSeasons = (newEvent: Partial<IAdminEvent>) =>
    clubSeasons.reduce((acc, season) => {
      const seasonStartsBeforeTheEvent = moment(season.start).isBefore(newEvent.start);
      const seasonEndsAfterTheEvent = moment(season.end).isAfter(newEvent.end);

      return acc || (seasonStartsBeforeTheEvent && seasonEndsAfterTheEvent);
    }, false);

  return eventFitsInEventsSeasons;
};
